<template>
  <div>
    <h1 class="text-center">Editorials</h1>
    <router-link
      class="btn-primary bg-green border-none leading-snug mb-2 inline-block px-4 py-2 text-white hover:bg-green-900 rounded-full no-underline"
      to="/editorial-add"
    >
      Create Editorial
    </router-link>
    <Table :endpoint="endpoint" :tableConfig="tableConfig" />
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import Table from "@/components/DataTable/Table"

export default {
  components: { Table },
  data() {
    return {
      endpoint: `${siteConfig.siteURL}admin/questions?search_by_type=11&fields=id,name,points,updated_on`,

      tableConfig: [
        {
          header: { textContent: "Name", sortingParam: "name" },
          classList: "w-1/2",
          path: "name",
        },
        {
          header: { textContent: "Id" },
          path: "id",
        },
        {
          header: { textContent: "Points", sortingParam: "points" },
          path: "points",
        },
        {
          header: { textContent: "Updated On", sortingParam: "updated_on" },
          type: "date",
          path: "updated_on",
        },
        {
          header: { textContent: "Option" },
          path: "id",
          type: "action",
          routePath: "/editorial/:id",
          actionButtonText: "Edit",
        },
      ],
    }
  },
}
</script>
